import React from 'react';

import SelectAcount from './SelectAcount';
import SelectSettings from './SelectSettings';

const Header = ({ title = 'title', children = null }) => {
  return (
    <>
      <div className="panel-head" style={{ zIndex: 5 }}>
        <h2 className="dash-title">{title}</h2>
        <div className="panel-head__group">
          {children}
          <div
            className="admin"
            style={{
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'center',
              margin: '0 0 0 10px',
            }}
          >
            <SelectSettings />
            <SelectAcount />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
